import { useState } from 'react'
import Modal from './Modal'
import Boton from './Boton'
import { presupuestosApi } from '../api/presupuestos'
import { colors, text, space, radius } from '../design/tokens'

/**
 * "Pegar pedido" (Martin, 13 sep 2026): el vendedor pega el texto de un mail
 * o WhatsApp con el pedido y la IA arma los renglones (artículo real + cantidad)
 * en vez de transcribirlos a mano. Esta pantalla SOLO interpreta — no agrega
 * nada; entrega el resultado a `onListo` para que el form abra el selector
 * único (SelectorArticulosModal) con esos renglones precargados, así el
 * vendedor siempre revisa antes de sumarlos al presupuesto.
 */
export default function ModalPegarPedido({ clienteId, onListo, onClose }) {
  const [texto, setTexto] = useState('')
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState(null)

  const interpretar = async () => {
    if (!texto.trim()) return
    setCargando(true)
    setError(null)
    try {
      const { data } = await presupuestosApi.interpretarPedido(texto.trim(), clienteId)
      onListo(data.renglones || [])
    } catch (e) {
      setError(e.response?.data?.message || 'No se pudo interpretar el pedido.')
    } finally {
      setCargando(false)
    }
  }

  return (
    <Modal title="Pegar pedido" onClose={onClose} maxWidth="640px">
      <p style={{ fontSize: text.sec, color: colors.textSec, marginTop: 0, lineHeight: 1.5 }}>
        Pegá el texto del mail o WhatsApp del pedido. La IA busca los artículos reales
        del catálogo y arma los renglones — después los revisás y ajustás antes de agregarlos.
      </p>
      <textarea
        autoFocus
        value={texto}
        onChange={e => setTexto(e.target.value)}
        placeholder={'Ej: "Hola, necesitaría 6 Rutini Malbec y 2 espumantes Otronia Brut para el sábado"'}
        rows={8}
        style={st.textarea}
      />
      {error && <div style={st.error}>{error}</div>}
      <div style={{ display: 'flex', gap: space.sm, marginTop: space.md }}>
        <Boton variante="ghost" onClick={onClose} style={{ flex: 1 }} disabled={cargando}>Cancelar</Boton>
        <Boton variante="primary" onClick={interpretar} style={{ flex: 2 }} disabled={cargando || !texto.trim()}>
          {cargando ? 'Interpretando…' : '✨ Interpretar con IA'}
        </Boton>
      </div>
    </Modal>
  )
}

const st = {
  textarea: {
    width: '100%', boxSizing: 'border-box', border: `1px solid ${colors.textPlh}`, borderRadius: radius.sm,
    padding: '10px 12px', fontSize: text.body, fontFamily: 'inherit', resize: 'vertical',
  },
  error: { marginTop: space.sm, color: colors.warn, background: colors.warnBg, border: `1px solid ${colors.warnBorder}`, borderRadius: radius.sm, padding: '8px 12px', fontSize: text.sec },
}
